<template>
    <div class="containerDebitDetail" :style="corPrimaria">
        <input id="campo_session_id" type="hidden" value="" />

        <div
            v-if="
                !enviarProposta &&
                !receberLigacao &&
                !contatoDigital &&
                parceiro != 'uol' &&
                parceiroConfig.identificador != 'ferragensnegocie'
            "
            class="row-options-buttons"
        >
            <div style="width: 100%">
                <button-default
                    v-if="
                        !parceiroConfig.sessoes.customization.campos.myDebits
                            .flgDesativarEnviarProposta
                    "
                    :style="'width: 100%'"
                    :color="parceiroConfigCorSecundariaCorPrimaria"
                    :secondary-color="true"
                    @click.native="enviarProposta = true"
                    text="Envie sua proposta"
                ></button-default>
            </div>
        </div>

        <template v-if="enviarProposta || parceiro == 'uol'">
            <send-proposal
                :divida="divida"
                @close="enviarProposta = false"
            ></send-proposal>
        </template>

        <template v-else-if="parceiro != 'uol'">
            <template v-if="parcelaSelected === null">
                <div id="div-data-primeiro-vencimento">
                    <h3>Data do primeiro vencimento</h3>

                    <v-date-picker
                        v-if="parceiroConfig.emp_codigo == 350"
                        id="input-data-primeiro-vencimento"
                        v-model="primeiroVencimento"
                        :style="{
                            color: parceiroConfig.estilo.corPrimaria,
                            'border-color': parceiroConfig.estilo.corPrimaria,
                        }"
                        :available-dates="datasDisponiveisVencimentoEntradaAcordo"
                    >
                        <template v-slot="{ inputValue, inputEvents }">
                        <input
                            :value="inputValue"
                            v-on="inputEvents"
                            style="border: none;"
                        />
                        </template>
                    </v-date-picker>

                    <input
                        v-else
                        id="input-data-primeiro-vencimento"
                        v-model="primeiroVencimento"
                        :style="{
                            color: parceiroConfig.estilo.corPrimaria,
                            'border-color': parceiroConfig.estilo.corPrimaria,
                        }"
                        :min="dataMinimaVencimento"
                        :max="dataLimite"
                        type="date"
                        pattern="[0-9]{2}/[0-9]{2}/[0-9]{4}"
                    />

                    <template v-if="aVistaOuAPrazo === 'P' && divida.loja.loj_fantasia.toLowerCase().includes('multicredito')">
                        <div id="div-down-payment">
                            <h3>Valor de entrada</h3>
                            <input
                                id="input-down-payment"
                                v-model="inputValorEntrada"
                                @blur="onBlur"
                                type="text"
                                :placeholder="`Valor mínimo: R$ ${valorMinimoEntradaFormatado}`"
                                :style="{
                                    color: parceiroConfig.estilo.corPrimaria,
                                    borderColor: parceiroConfig.estilo.corPrimaria
                                }"
                            />
                        </div>

                        <div id="div-installments">
                            <h3>Número de parcelas</h3>
                            <input
                                id="input-installments"
                                v-model="inputNumeroParcelas"
                                @blur="onBlurInstallments"
                                type="text"
                                :style="{
                                    color: parceiroConfig.estilo.corPrimaria,
                                    borderColor: parceiroConfig.estilo.corPrimaria
                                }"
                            />
                            <small class="helper-text">
                                Informe o número de parcelas desejado (1 a 7)
                            </small>
                        </div>
                    </template>

                    <button-default
                        @click.native="buscarNegociacoes"
                        style="margin-top: 20px"
                        :text="'Recalcular'"
                    ></button-default>                 
                </div>

                <h3>Qual a forma de pagamento?</h3>

                <div class="row-tabs">
                    <label
                        class="tab left"
                        :style="
                            aVistaOuAPrazo === 'A'
                                ? {
                                      color: parceiroConfig.estilo.corPrimaria,
                                      borderColor:
                                          parceiroConfig.estilo.corPrimaria,
                                  }
                                : 'var(primaryColor)'
                        "
                    >
                        <input
                            v-model="aVistaOuAPrazo"
                            type="radio"
                            id="a_vista"
                            value="A"
                            class="hide"
                            checked
                        />
                        À vista</label
                    >

                    <label
                        class="tab right"
                        :style="
                            aVistaOuAPrazo === 'P'
                                ? {
                                      color: parceiroConfig.estilo.corPrimaria,
                                      borderColor:
                                          parceiroConfig.estilo.corPrimaria,
                                  }
                                : 'var(primaryColor)'
                        "
                    >
                        <input
                            v-model="aVistaOuAPrazo"
                            type="radio"
                            id="a_prazo"
                            value="P"
                            class="hide"
                        />
                        Parcelado</label
                    >
                </div>

                <h3>Você quer pagar por?</h3>

                <div class="row-tabs">
                    <label
                        class="tab left"
                        :style="
                            typePayment === 'boleto'
                                ? {
                                      color: parceiroConfig.estilo.corPrimaria,
                                      borderColor:
                                          parceiroConfig.estilo.corPrimaria,
                                  }
                                : 'var(primaryColor)'
                        "
                    >
                        <input
                            id="boleto"
                            v-model="typePayment"
                            type="radio"
                            value="boleto"
                            class="hide"
                        />
                        Boleto</label
                    >

                    <label
                        v-if="
                            !parceiroConfig.sessoes.customization.campos
                                .myDebits.flgDesativarPix
                        "
                        class="tab"
                        :style="
                            typePayment === 'pix'
                                ? {
                                      color: parceiroConfig.estilo.corPrimaria,
                                      borderColor:
                                          parceiroConfig.estilo.corPrimaria,
                                  }
                                : 'var(primaryColor)'
                        "
                    >
                        <input
                            id="pix"
                            v-model="typePayment"
                            type="radio"
                            value="pix"
                            class="hide"
                        />
                        PIX</label
                    >

                    <label
                        v-if="
                            !parceiroConfig.sessoes.customization.campos
                                .myDebits.flgDesativarCartaoCredito
                        "
                        class="tab right"
                        :style="
                            typePayment === 'cartao'
                                ? {
                                      color: parceiroConfig.estilo.corPrimaria,
                                      borderColor:
                                          parceiroConfig.estilo.corPrimaria,
                                  }
                                : 'var(primaryColor)'
                        "
                    >
                        <input
                            id="cartao"
                            v-model="typePayment"
                            type="radio"
                            value="cartao"
                            class="hide"
                        />
                        Cartão de Crédito</label
                    >
                </div>

                <template
                    v-if="
                        typePayment == 'cartao' &&
                        parceiroConfig.identificador == 'mw'
                    "
                >
                    <h3>Forma do cartão</h3>

                    <div
                        v-if="
                            divida.loja.loj_cartao_de_credito_recorrente == 'S'
                        "
                        class="row-tabs"
                    >
                        <label
                            class="tab"
                            :style="
                                formaCartao === 'a_vista'
                                    ? {
                                          color: parceiroConfig.estilo
                                              .corPrimaria,
                                          borderColor:
                                              parceiroConfig.estilo.corPrimaria,
                                      }
                                    : 'var(primaryColor)'
                            "
                        >
                            <input
                                type="radio"
                                value="a_vista"
                                v-model="formaCartao"
                                class="hide"
                            />
                            à vista
                        </label>

                        <label
                            class="tab"
                            :style="
                                formaCartao === 'parcelado'
                                    ? {
                                          color: parceiroConfig.estilo
                                              .corPrimaria,
                                          borderColor:
                                              parceiroConfig.estilo.corPrimaria,
                                      }
                                    : 'var(primaryColor)'
                            "
                        >
                            <input
                                type="radio"
                                value="parcelado"
                                v-model="formaCartao"
                                class="hide"
                            />
                            recorrente
                        </label>
                    </div>
                    <div
                        v-if="
                            divida.loja.loj_cartao_de_credito_recorrente == 'S'
                        "
                    >
                        <h1 style="margin-top: 20px">{{ textoFormaCartao }}</h1>
                    </div>
                </template>

                <div
                    v-if="
                        typePayment == 'cartao' &&
                        parceiroConfig.identificador == 'mw'
                    "
                    style="margin-bottom: 20px"
                >
                    <h3>SELECIONE A BANDEIRA DO SEU CARTÃO</h3>
                    <select
                        class="select-bandeira-cartao"
                        :style="{
                            border:
                                '3px solid' + parceiroConfig.estilo.corPrimaria,
                        }"
                        v-model="bandeiraCartao"
                    >
                        <option value="MASTERCARD">MASTERCARD</option>
                        <option value="VISA">VISA</option>
                        <option value="ELO">ELO</option>
                        <option value="HIPERCOB">HIPERCARD</option>
                        <option value="OTHER">OUTRA</option>
                    </select>
                </div>

                <div class="container-option-payment" style="margin-top: 30px">
                    <h3>{{ tituloListaDePagamentos }}</h3>

                    <template v-if="lancamentosFuturos.aVista.length > 0">
                        <div v-if="lancamentosFuturosObrigatorios">
                            <label
                                >Obs.: Lançamentos futuros inclusos no
                                cálculo</label
                            >
                        </div>

                        <div v-else class="checkBoxFuturePayment">
                            <input
                                type="checkbox"
                                v-model="somarFuturosInput"
                            />
                            <label
                                >Marque essa opção, caso queira incluir os
                                lançamentos futuros a sua negociação!</label
                            >
                        </div>
                    </template>

                    <monthly-payment-card
                        v-for="parcela in parcelas"
                        :key="parcela.pra_codigo"
                        :typePayment="typePayment"
                        :parcela="parcela"
                        :divida="divida"
                        @click.native="clicouNoCard(parcela)"
                    ></monthly-payment-card>

                    <h6 class="message-empty" v-if="parcelas === 0">
                        {{
                            `Nenhuma opção de pagamento encontrada para a forma ${
                                typePayment === "cartao"
                                    ? `cartão de
                        crédito`
                                    : "boleto"
                            }.`
                        }}
                    </h6>
                </div>

                <div
                    v-if="
                        parceiroConfig.identificador == 'ferragensnegocie' &&
                        !parceiroConfig.sessoes.customization.campos.myDebits
                            .flgDesativarEnviarProposta
                    "
                    class="row-options-buttons"
                >
                    <div style="width: 100%; padding-top: 20px;">
                        <button-default
                            :style="'width: 100%'"
                            :color="parceiroConfigCorSecundariaCorPrimaria"
                            :secondary-color="true"
                            @click.native="enviarProposta = true"
                            text="Envie sua proposta"
                        ></button-default>
                    </div>
                </div>
            </template>

            <details-monthly-payment
                v-else
                :parcela="parcelaSelected"
                :divida="divida"
                :tipoPagamento="typePayment"
                :lancamentosFuturos="lancamentosFuturos"
                :sessionIdNetCred="sessionIdNetCred"
                :formaCartao="formaCartao"
                @backOption="parcelaSelected = null"
            ></details-monthly-payment>
        </template>

        <div
            v-if="mostrarModalSegundaViaSenff"
            class="background"
            @keypress.enter="continuar()"
        >
            <div class="dialog-box info">
                <i class="fas fa-info-circle" />
                <h6>Segunda via</h6>
                <p>
                    Não é possível fazer acordo à vista tendo boleto da segunda
                    via disponível
                </p>
                <button @click="continuar()" class="btn-modal info">
                    2ª Via da Fatura
                </button>
                <button
                    @click="mostrarParcelamentos()"
                    class="btn-modal info"
                    style="margin-top: 10px"
                >
                    Parcelar Fatura
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, createNamespacedHelpers } from "vuex";
import globalMethods from "@/mixins/globalMethods";
import mixins from "@/mixins/mixins";

import ButtonDefault from "@/components/buttons/ButtonDefault";
import DetailsMonthlyPayment from "./DetailsMonthlyPayment";
import Template from "@/views/admin/Template";
import MonthlyPaymentCard from "./MonthlyPaymentCard";
import SendProposal from "./SendProposal";
import ReceiveCall from "./ReceiveCall";
import DigitalContact from "./DigitalContact";

const {
    mapState: mapStatePassosRetornarDividas,
    mapActions: mapActionsPassosRetornarDividas,
    mapMutations: mapMutationsPassosRetornarDividas,
    mapGetters: mapGettersPassosRetornarDividas,
} = createNamespacedHelpers("passosRetornarDividas");

let dataAtual = new Date();
let dia =
    dataAtual.getDate() > 9 ? dataAtual.getDate() : `0${dataAtual.getDate()}`;
let mes =
    dataAtual.getMonth() + 1 > 9
        ? dataAtual.getMonth() + 1
        : `0${dataAtual.getMonth() + 1}`;
dataAtual = `${dataAtual.getFullYear()}-${mes}-${dia}`;

export default {
    name: "PaymentOptionsDebit",

    components: {
        DigitalContact,
        ReceiveCall,
        SendProposal,
        MonthlyPaymentCard,
        Template,
        DetailsMonthlyPayment,
        ButtonDefault,
    },

    mixins: [globalMethods, mixins],

    props: {
        divida: {
            type: Object,
            required: true,
        },

        lancamentosFuturos: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            typePayment: "boleto",
            parcelaSelected: null,
            enviarProposta: false,
            receberLigacao: false,
            contatoDigital: false,
            sliderVModel: "",
            somarFuturosInput: false,
            parcelas: [],
            parcelasAvista: [],
            parcelasPrazo: [],
            aVistaOuAPrazo: "A",
            preCodigo: [],
            dataDeHoje: dataAtual,
            primeiroVencimento: dataAtual,
            primeiroVencimentoAnterior: dataAtual,
            sessionIdNetCred: "",
            bandeiraCartao: "MASTERCARD",
            porcentagemRecorrente: "2,99%",
            porcentagem1X: "2,49%",
            parcelamentoLinha2: "2X - 6X",
            porcentagemLinha2: "2,60%",
            parcelamentoLinha3: "7X - 12X",
            porcentagemLinha3: "2,99%",
            formaCartao: "a_vista",
            blur: false,
            enter: false,
            mostrarModalSegundaViaSenff: false,
            valorEntrada: 0,
            inputValorEntrada: "",
            inputNumeroParcelas: "",
            numeroParcelas: 0,
        };
    },

    computed: {
        ...mapState({
            escolhaFiltro: (estado) => estado.escolhaFiltro,
            corPrimaria: (estado) => estado.corPrimaria,
            corSecundaria: (estado) => estado.corSecundaria,
        }),

        ...mapStatePassosRetornarDividas({
            botaoConsultarParcelamentosClicado: (estado) =>
                estado.botaoConsultarParcelamentosClicado,
            pessoa: (estado) => estado.pessoa,
        }),

        valorMinimoEntradaFormatado() {
            const valorMinimo = this.getValorMinimoEntradaMulticredito();
            return valorMinimo ? this.formatarDinheiro(valorMinimo) : '0,00';
        },

        dataMinimaVencimento() {
            const valorMinimo = this.getValorMinimoEntradaMulticredito();
            if (valorMinimo && valorMinimo > 0) {
                const amanha = new Date();
                amanha.setDate(amanha.getDate() + 1);
                let dia = amanha.getDate() > 9 ? amanha.getDate() : `0${amanha.getDate()}`;
                let mes = amanha.getMonth() + 1 > 9 ? amanha.getMonth() + 1 : `0${amanha.getMonth() + 1}`;
                return `${amanha.getFullYear()}-${mes}-${dia}`;
            } else {
                if (
                    this.divida.loja.prazo_minimo_entrada == undefined ||
                    this.divida.loja.prazo_minimo_entrada == null ||
                    this.divida.loja.prazo_minimo_entrada == "" ||
                    this.divida.loja.prazo_minimo_entrada === false
                ) {
                    this.divida.loja.prazo_minimo_entrada = 0;
                }

                const dataMinimaEntrada = new Date();
                dataMinimaEntrada.setDate(Number.parseInt(dataMinimaEntrada.getDate()) + Number.parseInt(this.divida.loja.prazo_minimo_entrada));
                let dia = dataMinimaEntrada.getDate() > 9 ? dataMinimaEntrada.getDate() : `0${dataMinimaEntrada.getDate()}`;
                let mes = dataMinimaEntrada.getMonth() + 1 > 9 ? dataMinimaEntrada.getMonth() + 1 : `0${dataMinimaEntrada.getMonth() + 1}`;
                return `${dataMinimaEntrada.getFullYear()}-${mes}-${dia}`;
            }
        },

        dataLimite() {
            let dataAgoraEmMilisegundos = Date.now();
            let milisegundosDataLimite =
                this.divida.loja.prazo_maximo_entrada_site * 86400000;
            let dataLimite = new Date(
                dataAgoraEmMilisegundos + milisegundosDataLimite
            );
            let mes =
                dataLimite.getMonth() + 1 > 9
                    ? dataLimite.getMonth() + 1
                    : `0${dataLimite.getMonth() + 1}`;
            let dia =
                dataLimite.getDate() > 9
                    ? dataLimite.getDate()
                    : `0${dataLimite.getDate()}`;
            return `${dataLimite.getFullYear()}-${mes}-${dia}`;
        },

        lancamentosFuturosObrigatorios() {
            let obrigatorio = false;

            for (const lancamentoFuturo in this.lancamentosFuturos.aVista) {
                if (lancamentoFuturo.lancamento_futuro_obrigatorio === "1") {
                    obrigatorio = true;
                }
            }

            return obrigatorio;
        },

        textoFormaCartao() {
            if (this.formaCartao == "a_vista") {
                return "Modalidade normal de crédito, uma compra com a quantidade de parcelamentos escolhida";
            } else {
                return "O pagamento recorrente é um método de pagamento em que o valor da parcela acordada é cobrado automaticamente do seu cartão de crédito em intervalos mensais e o limite total do acordo não compromete o limite do seu cartão de crédito.";
            }
        },

        tituloListaDePagamentos() {
            if (this.parcelas.length === 0) {
                return "Não existem propostas disponíveis para esse(s) contrato(s)!";
            } else if (this.divida.length === 0) {
                return "Esta opção de pagamento não está disponível!";
            } else {
                return "Selecione o valor e a quantidade das parcelas que você quer pagar";
            }
        },

        datasDisponiveisVencimentoEntradaAcordo() {
            const retorno = [];

            for (let data of this.divida.loja.vencimentos_permitidos_entrada_acordo) {
                let dataArr = data.split("-");

                retorno.push(
                    new Date(
                        Number(dataArr[0]),
                        Number(dataArr[1]) - 1,
                        Number(dataArr[2]),
                    )
                );
            }

            return retorno;
        }
    },

    watch: {
        aVistaOuAPrazo() {
            if (this.aVistaOuAPrazo === 'P') {
                const valorMinimo = this.getValorMinimoEntradaMulticredito();
                if (valorMinimo && valorMinimo > 0) {
                    const dataMinima = this.dataMinimaVencimento;
                    if (new Date(this.primeiroVencimento) < new Date(dataMinima)) {
                        this.primeiroVencimento = dataMinima;
                    }
                }
            }
            this.buscarNegociacoes();
        },
        somarFuturosInput() {
            this.buscarNegociacoes();
        },
        typePayment() {
            this.buscarNegociacoes();
        },
        bandeiraCartao() {
            this.buscarNegociacoes();
        },
        formaCartao() {
            this.buscarNegociacoes();
        },
        valorEntrada() {
            const valorMinimo = this.getValorMinimoEntradaMulticredito();
            if (valorMinimo && this.valorEntrada < valorMinimo) {
                this.valorEntrada = Math.round(valorMinimo * 100) / 100;
            }

            this.inputValorEntrada = this.formatarValorEntrada(this.valorEntrada);
        },
    },

    created() {
        if (this.parceiroConfig.identificador == "mw") {
            (function (a, b, c, d, e, f, g) {
                a["CsdpObject"] = e;
                (a[e] =
                    a[e] ||
                    function () {
                        (a[e].q = a[e].q || []).push(arguments);
                    }),
                    (a[e].l = 1 * new Date());
                (f = b.createElement(c)), (g = b.getElementsByTagName(c)[0]);
                f.async = 1;
                f.src = d;
                g.parentNode.insertBefore(f, g);
            })(
                window,
                document,
                "script",
                "//device.clearsale.com.br/p/fp.js",
                "csdp"
            );
            csdp("app", "wsbv4xilxnqq3y08mb3b");
            csdp("outputsessionid", "campo_session_id");
            this.sessionIdNetCred = document.getElementById("campo_session_id");

            csdp("inputsessionid", this.sessionIdNetCred);
        }
    },

    beforeMount() {
        const valorMinimo = this.getValorMinimoEntradaMulticredito();
        
        this.valorEntrada = valorMinimo && valorMinimo > 0 ? valorMinimo : 0;
        this.inputValorEntrada = this.formatarValorEntrada(this.valorEntrada);
        
        this.numeroParcelas = 1;
        this.inputNumeroParcelas = "1";

        if (valorMinimo && valorMinimo > 0) {
            const amanha = new Date();
            amanha.setDate(amanha.getDate() + 1);
            let dia = amanha.getDate() > 9 ? amanha.getDate() : `0${amanha.getDate()}`;
            let mes = amanha.getMonth() + 1 > 9 ? amanha.getMonth() + 1 : `0${amanha.getMonth() + 1}`;
            this.dataDeHoje = `${amanha.getFullYear()}-${mes}-${dia}`;

            this.valorEntrada = Math.round(valorMinimo * 100) / 100;
            this.inputValorEntrada = this.formatarValorEntrada(this.valorEntrada);
        }
        this.primeiroVencimento = this.dataMinimaVencimento;
        if (this.parceiroConfig.emp_codigo == 350) {
            let arrData = this.dataMinimaVencimento.split("-");

            this.primeiroVencimento = new Date(
                Number(arrData[0]),
                Number(arrData[1]) - 1,
                Number(arrData[2])
            );
        }

        this.retornarPreCodigoPorDivida();
        this.buscarNegociacoes();
    },

    mounted() {
        this.acaoSalvarEtapa({
            pes_cpf_cnpj: this.pessoa.pesCpfCnpj,
            pes_codigo: this.pessoa.pes_codigo,
            esn_fk_ets_codigo: 39,
            emp_codigo: this.parceiroConfig.emp_codigo,
            data_agendamento: this.dataAtual,
            hora_agendamento: this.horaAtual,
            motivo_agendamento: "Vizualizou as parcelas da dívida",
        });

        if (this.parceiroConfig.identificador == "mw") {
            (function (a, b, c, d, e, f, g) {
                a["CsdpObject"] = e;
                (a[e] =
                    a[e] ||
                    function () {
                        (a[e].q = a[e].q || []).push(arguments);
                    }),
                    (a[e].l = 1 * new Date());
                (f = b.createElement(c)), (g = b.getElementsByTagName(c)[0]);
                f.async = 1;
                f.src = d;
                g.parentNode.insertBefore(f, g);
            })(
                window,
                document,
                "script",
                "//device.clearsale.com.br/p/fp.js",
                "csdp"
            );
            csdp("app", "seu_app");
            csdp("sessionid", this.sessionIdNetCred);
        }
    },

    methods: {
        ...mapGettersPassosRetornarDividas([
            "getPesCpf",
            "getTemSegundaViaSenff",
            "getArraySegundaViaSenff",
            "getValorMinimoEntradaMulticredito",
        ]),

        ...mapActionsPassosRetornarDividas([
            "acaoPasso3ConsultarNegociacoes",
            "acaoPasso3ConsultarNegociacoesStage",
        ]),

        ...mapMutationsPassosRetornarDividas(["SET_A_VISTA_OU_A_PRAZO"]),

        retornarPreCodigoPorDivida() {
            let contratos = null;
            this.preCodigo = [];

            if (
                this.parceiroConfig.sessoes.customization.campos.myDebits
                    .flgPortalUsaStage
            ) {
                Object.values(this.divida.contratos).forEach((contrato) => {
                    let preCodigos = contrato.parcelas.map(
                        (parcela) => parcela.pre_codigo
                    );
                    this.preCodigo.push(...preCodigos);
                });
            } else {
                if (this.aVistaOuAPrazo === "P") {
                    contratos = this.divida.contratos_aprazo;
                } else if (this.aVistaOuAPrazo === "A") {
                    contratos = this.divida.contratos_avista;
                }

                for (const contrato in contratos) {
                    for (const parcela in contratos[contrato].parcelas) {
                        this.preCodigo.push(
                            contratos[contrato].parcelas[parcela].pre_codigo
                        );
                    }
                }
            }
        },

        retornarPreCodigosPorLancamentosFuturos() {
            let parcelas = null;

            if (this.aVistaOuAPrazo === "P") {
                parcelas = this.lancamentosFuturos.aPrazo;
            } else if (this.aVistaOuAPrazo === "A") {
                parcelas = this.lancamentosFuturos.aVista;
            }

            for (const parcela in parcelas) {
                this.preCodigo.push(parcelas[parcela].pre_codigo);
            }
        },

        verificarData() {
            const dataInput = new Date(this.primeiroVencimento);
            const dataMinimaEmDate = new Date(this.dataMinimaVencimento);
            const dataLimite = new Date(this.dataLimite);

            let ehMenorDoQueDataMinima =
                dataInput.getTime() < dataMinimaEmDate.getTime() ? true : false;
            let ehMaiorDoQueDataMaxima =
                dataInput.getTime() > dataLimite.getTime() ? true : false;

            if (ehMenorDoQueDataMinima || ehMaiorDoQueDataMaxima) {
                this.CHANGE_MESSAGE_MODAL({
                    show: true,
                    title: "Erro",
                    message: `Data de vencimento passada é inválida, a data máxima possível é: ${this.formatarData(
                        this.dataLimite
                    )}`,
                    styleMessage: "danger",
                });
                this.SET_LOADING(false);
                this.SET_LOADING_MESSAGE("");
                this.parcelas = [];
                this.primeiroVencimento = this.dataMinimaVencimento;
                return false;
            } else {
                this.primeiroVencimentoAnterior = this.primeiroVencimento;
            }
            return true;
        },

        buscarNegociacoes() {
            this.SET_LOADING(true);
            this.SET_LOADING_MESSAGE("Consultando os valores para negociação");
            this.retornarPreCodigoPorDivida();

            if (this.somarFuturosInput) {
                this.retornarPreCodigosPorLancamentosFuturos();
            }
            if (
                (this.aVistaOuAPrazo === "A" || this.aVistaOuAPrazo === "P") &&
                this.verificarData()
            ) {
                this.parcelas = [];
                if (
                    this.parceiroConfig.sessoes.customization.campos.myDebits
                        .flgPortalUsaStage &&
                    this.botaoConsultarParcelamentosClicado
                ) {
                    let primeiroVencimento = this.primeiroVencimento;
                    if (this.parceiroConfig.emp_codigo == 350) {
                        let dia = String(this.primeiroVencimento.getDate()).padStart(2, "0");
                        let mes = String(this.primeiroVencimento.getMonth() + 1).padStart(2, "0");

                        primeiroVencimento = `${this.primeiroVencimento.getFullYear()}-${mes}-${dia}`;
                    }

                    const requestData = {
                        lojCodigo: this.divida.loja.loj_codigo,
                        preCodigo: this.preCodigo,
                        primeiroVencimento,
                        pagamentoAvistaPrazo: this.aVistaOuAPrazo,
                        metodoPagamento: this.typePayment,
                    };

                    if (this.aVistaOuAPrazo === 'P') {
                        requestData.valorEntrada = Math.round(this.valorEntrada * 100) / 100;
                        requestData.numeroParcelas = this.numeroParcelas;
                    }

                    this.acaoPasso3ConsultarNegociacoesStage(requestData)
                        .then((resposta) => {
                            if (!resposta.retorno) {
                                this.CHANGE_MESSAGE_MODAL({
                                    show: true,
                                    title: "Erro",
                                    message: resposta.mensagem,
                                    styleMessage: "danger",
                                });
                                this.primeiroVencimento = this.dataMinimaVencimento;
                            } else {
                                if (
                                    resposta.dados.pre_acordo.length > 1 &&
                                    resposta.dados.pre_acordo[0]
                                        .pra_quantidade == 0
                                ) {
                                    resposta.dados.pre_acordo.shift();
                                }
                                this.parcelas.push(
                                    ...resposta.dados.pre_acordo
                                );
                            }
                            this.SET_LOADING(false);
                            this.SET_LOADING_MESSAGE("");
                        })
                        .catch(() => {
                            this.SET_LOADING(false);
                            this.SET_LOADING_MESSAGE("");
                            this.CHANGE_MESSAGE_MODAL({
                                show: true,
                                title: "Erro",
                                message:
                                    "Não foi possível calcular as simulações, volte para a página inicial e tente novamente.",
                                styleMessage: "danger",
                            });
                            this.primeiroVencimento = this.dataMinimaVencimento;
                        });
                } else {
                    let primeiroVencimento = this.primeiroVencimento;
                    if (this.parceiroConfig.emp_codigo == 350) {
                        let dia = String(this.primeiroVencimento.getDate()).padStart(2, "0");
                        let mes = String(this.primeiroVencimento.getMonth() + 1).padStart(2, "0");

                        primeiroVencimento = `${this.primeiroVencimento.getFullYear()}-${mes}-${dia}`;
                    }

                    const requestData = {
                        lojCodigo: this.divida.loja.loj_codigo,
                        preCodigo: this.preCodigo,
                        primeiroVencimento,
                        pagamentoAvistaPrazo: this.aVistaOuAPrazo,
                        metodoPagamento: this.typePayment,
                        bandeiraCartao: this.bandeiraCartao,
                        formaCartao: this.formaCartao,
                    };
                    
                    if (this.aVistaOuAPrazo === 'P') {
                        requestData.valorEntrada = Math.round(this.valorEntrada * 100) / 100;
                        requestData.numeroParcelas = this.numeroParcelas;
                    }
                    
                    this.acaoPasso3ConsultarNegociacoes(requestData).then((resposta) => {
                        this.SET_LOADING(false);
                        this.SET_LOADING_MESSAGE("");
                        if (!resposta.retorno) {
                            this.CHANGE_MESSAGE_MODAL({
                                show: true,
                                title: "Erro",
                                message: resposta.mensagem,
                                styleMessage: "danger",
                            });
                            this.primeiroVencimento = this.dataMinimaVencimento;
                        } else {
                            if (
                                resposta.dados.pre_acordo.length > 1 &&
                                resposta.dados.pre_acordo[0].pra_quantidade == 0 &&
                                this.aVistaOuAPrazo == "P"
                            ) {
                                resposta.dados.pre_acordo.shift();
                            } else {
                                resposta.dados.pre_acordo = [resposta.dados.pre_acordo.shift()];
                            }

                            this.parcelas.push(...resposta.dados.pre_acordo);
                        }
                    });
                }
            }
        },

        clicouNoCard(parcela) {
            let temSegundaViaSenff = false;
            Object.values(this.divida.contratos).some((contrato) => {
                temSegundaViaSenff =
                    this.getArraySegundaViaSenff().filter((elemento) => {
                        return elemento.contrato == contrato.con_contrato;
                    }).length > 0;

                if (temSegundaViaSenff) {
                    return true;
                }
            });

            if (
                this.parceiroConfig.identificador == "Senff" &&
                temSegundaViaSenff &&
                parcela.pra_quantidade == 0 &&
                this.somarFuturosInput == false
            ) {
                this.mostrarModalSegundaViaSenff = true;
                return;
            }

            if (this.verificarData()) {
                this.parcelaSelected = parcela;
            }
        },

        continuar() {
            this.mostrarModalSegundaViaSenff = false;

            this.$emit("mostrarSegundaVia");
        },

        mostrarParcelamentos() {
            this.mostrarModalSegundaViaSenff = false;
            this.aVistaOuAPrazo = "P";
        },

        formatarValorEntrada(valor) {
            if (valor === null || valor === undefined || valor === "") {
                return "";
            }
            return this.formatarDinheiro(valor);
        },

        parsearValorEntrada(valor) {
            if (valor === null || valor === undefined || valor === "") {
                return 0;
            }
            let valorLimpo = valor.toString()
                .replace(/R\$\s*/g, '')
                .replace(/\s/g, '')
                .replace(/\./g, '')
                .replace(/,/g, '.');
            
            const valorNumerico = parseFloat(valorLimpo);
            return isNaN(valorNumerico) ? 0 : valorNumerico;
        },

        onBlur() {
            const valor = this.parsearValorEntrada(this.inputValorEntrada);
            
            const valorMinimo = this.getValorMinimoEntradaMulticredito();
            if (valorMinimo && valor < valorMinimo) {
                this.valorEntrada = Math.round(valorMinimo * 100) / 100;
                this.inputValorEntrada = this.formatarValorEntrada(this.valorEntrada);
            } else {
                this.valorEntrada = Math.round(valor * 100) / 100;
                this.inputValorEntrada = this.formatarValorEntrada(this.valorEntrada);
            }
        },

        onBlurInstallments() {
            const numero = this.parsearNumeroParcelas(this.inputNumeroParcelas);
            
            if (numero < 1) {
                this.numeroParcelas = 1;
                this.inputNumeroParcelas = "1";
            } else if (numero > 7) {
                this.numeroParcelas = 7;
                this.inputNumeroParcelas = "7";
            } else {
                this.numeroParcelas = numero;
                this.inputNumeroParcelas = numero.toString();
            }
        },

        parsearNumeroParcelas(valor) {
            if (valor === null || valor === undefined || valor === "") {
                return 0;
            }
            const valorLimpo = valor.toString().replace(/\D/g, '');
            const valorNumerico = parseInt(valorLimpo);
            return isNaN(valorNumerico) ? 0 : valorNumerico;
        },
    },
};
</script>

<style scoped>
.containerDebitDetail {
    width: 100%;
    box-sizing: border-box;
    max-width: 1024px;
    padding: 30px;
    background: var(--whiteColor);
    border-radius: 40px;
    box-shadow: 0 1px 2px rgba(3, 27, 78, 0.16);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    margin-bottom: 100px;
}

.header-debits {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    max-width: 1024px;
    cursor: pointer;
}

h3 {
    margin: 30px 0px;
    color: #031b4e;
    font-family: "Roboto Black";
    text-transform: uppercase;
    font-size: 16px;
    text-align: center;
}

.header-debits i {
    font-size: 48px;
    color: #031b4e;
}

.row-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
}

.container-option-payment {
    padding: 30px 0;
    max-height: 500px;
    overflow-y: auto;
}

.container-option-payment::-webkit-scrollbar {
    width: 5px;
    height: 0;
}

.container-option-payment::-webkit-scrollbar-thumb {
    background: #9a9a9a;
}

.row-tabs {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 0 0 0 0;
}

.tab {
    width: 100%;
    text-align: center;
    font-size: 16px;
    text-transform: uppercase;
    padding: 10px 0;
    border-bottom: 3px solid transparent;
    font-family: "Roboto Black";
    color: #9a9a9a;
}

.tab.active {
    border-bottom: 3px solid var(--color);
    font-family: "Roboto Black";
    color: var(--color);
}

.tab:hover {
    cursor: pointer;
}

.message-empty {
    text-align: center;
    padding: 40px 0;
    font-size: 14px;
    font-family: Roboto;
    color: #5b6987;
}

.row-options-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
}

.row-options-buttons div {
    padding: 0 2px;
    margin-bottom: 5px;
}

.checkBoxFuturePayment {
    margin: 10px 0px;
    color: #d33724;
    font-family: "Roboto Black";
    /* text-transform: uppercase; */

    text-align: center;
}

.checkBoxFuturePayment label {
    font-size: 18px;
    font-weight: bold;
}

@media only screen and (max-width: 600px) {
    .row-options-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .row-options-buttons div {
        padding: 0px;
        margin-bottom: 5px;
        width: 100%;
    }
}

.opcoes_de_pagamento {
    display: flex;
    justify-content: space-around;
}

.opcoes_de_pagamento label {
    font-size: 16px;
    font-family: "Roboto Black";
    color: #031b4e;
}

#div-data-primeiro-vencimento {
    margin: 5px 0px;
    display: flex;
    flex-direction: column;
    align-self: center;
    align-items: center;
}

#div-data-primeiro-vencimento label {
    color: #031b4e;
    font-family: "Roboto Black";
    font-size: 16px;
}

#input-data-primeiro-vencimento {
    border-radius: 25px;
    border: 3px solid #031b4e;
    width: 200px;
    margin-top: 5px;
    float: right;
    padding: 5px;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
}

#div-down-payment {
    margin: 0px;
    display: flex;
    flex-direction: column;
    align-self: center;
    align-items: center;
}

#input-down-payment {
    border-radius: 25px;
    border: 3px solid #031b4e;
    width: 200px;
    margin-top: 5px;
    float: right;
    padding: 5px;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
}

#div-installments {
    margin: 0px;
    display: flex;
    flex-direction: column;
    align-self: center;
    align-items: center;
}

#input-installments {
    border-radius: 25px;
    border: 3px solid #031b4e;
    width: 200px;
    margin-top: 5px;
    float: right;
    padding: 5px;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
}

.helper-text {
    margin-top: 8px;
    color: #666;
    font-size: 12px;
    font-family: "Roboto";
    text-align: center;
    max-width: 200px;
}

.hide {
    display: none;
}

.select-bandeira-cartao {
    border-radius: 20px;
    background-color: #fff;
    width: 80%;
    margin-left: 10%;
    margin-right: 10%;
}

.background {
    background-color: rgba(0, 0, 0, 0.9);
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 500;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.dialog-box {
    background: #ffffff;
    width: 333px;
    padding: 40px;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
}

.dialog-box i {
    font-size: 100px;
    margin: 0 0 40px 0;
}

.dialog-box.info i {
    color: rgb(45, 76, 148);
}

.dialog-box h6 {
    font-family: "Roboto Black";
    font-weight: normal;
    font-size: 24px;
    color: var(--blackColor);
    margin-bottom: 15px;
    line-height: 28px;
}

.dialog-box p {
    white-space: pre-line;
    font-size: 15px;
    font-family: "Roboto";
    color: var(--blackColor);
    margin-bottom: 30px;
}

.btn-modal {
    height: 48px;
    padding: 0 48px;
    color: #ffffff;
    font-family: "Roboto Black";
    font-size: 15px;
    border-radius: 20px;
    border: 0;
    cursor: pointer;
}

.dialog-box.info .btn-modal {
    background: rgb(45, 76, 148);
}
</style>
